import FilesRepository from "@/Repositories/FilesRepository";
import {mapState} from "pinia";
import {DataGatheringsStore} from "@/Store/DataGatherings/DataGatheringsStore";
import _ from "lodash";
import DataGatheringRepository from "@/Repositories/DataGathering/DataGatheringRepository";
import {
    DataStrategyValidations,
    DataTypeValidations,
    ModeValidations,
} from "@/Shared/DathaGatherings/Validations";
import {toHumanSize} from "@/helpers";
import GoogleDriveFilePicker from "@/Shared/Files/GoogleDriveFilePicker.vue";
import DragAndDropFilePicker from "@/Shared/Files/DragAndDropFilePicker.vue";

export default {
    components: {GoogleDriveFilePicker, DragAndDropFilePicker},

    data: () => ({
        data_gathering: DataGatheringRepository.build(),

        data_gathering_rules: {
            data_type: DataTypeValidations.all(),
            data_strategy: DataStrategyValidations.all(),
            mode: ModeValidations.all(),
        },

        spreadSheetData: {
            file_name: null,
            size: null,
        },

        selected_mode: null,
    }),

    methods: {
        async uploadFile(file) {
            this.flags.file_loading = false;

            const values = {
                expires_in: '30 days',
            };

            return FilesRepository.upload(file, values)
                .then(response => {
                    this.data_gathering.setDataProvider('excel_document', response.data);
                    this.spreadSheetData.file_name = file.name;
                    this.spreadSheetData.size = file.size;
                })
                .catch(error => this.onHttpErrorDefaultHandler(error, {file}))
                .finally(() => this.flags.file_loading = false);
        },

        async deleteFile(file) {
            this.flags.file_loading = true;

            return FilesRepository.delete(file)
                .then(response => {
                    this.toast().info(this.$t('app.file_removed'));

                    this.data_gathering.removeDataProvider();
                    this.spreadSheetData.file_name = null;
                    this.spreadSheetData.size = null;
                })
                .catch(error => this.onHttpErrorDefaultHandler(error, {file}))
                .finally(() => this.flags.file_loading = false);
        },

        async removeSpreadSheet() {
            const dataProvider = this.data_gathering.getOptions().data_provider;

            if (dataProvider && dataProvider.name === 'excel_document') {
                //if a excel document was upload we must destroy the document
                return this.deleteFile(dataProvider);
            }
        },

        /**
         *
         * @param {Object} dataGathering
         */
        clone(dataGathering) {
            this.data_gathering = DataGatheringRepository.build(dataGathering);

            this.data_gathering.setUuid(dataGathering.uuid);
        },
    },

    computed: {
        selectedType() {
            const types = this.types;

            return types.firstOf(type => type.id === this.data_gathering.type.id);
        },

        strategies() {
            return _.get(this.selectedType, 'strategies', []);
        },

        selectedStrategy() {
            const strategies = _.get(this.selectedType, 'strategies', []);

            return strategies.firstOf(strategy => strategy.id === this.data_gathering.strategy.id);
        },

        availableModes() {
            let modes = [];

            if(this.googleDrive || this.excelDocument) {
                modes.push({
                    value: 'manual',
                    title: 'Manual'
                });
            }

            if(this.dbFetch){
                modes.push({
                    value: 'db_fetch',
                    title: 'Automatic'
                });
            }

            return modes;
        },

        spreadSheetSelected() {
            return !!this.spreadSheetData.file_name;
        },

        supportSpreadSheetImport() {
            return this.googleDrive || this.excelDocument;
        },

        googleDrive() {
            return _.get(this.selectedStrategy, 'options.data_providers.google_sheet');
        },

        excelDocument() {
            return _.get(this.selectedStrategy, 'options.data_providers.google_sheet');
        },

        dbFetch() {
            return _.get(this.selectedStrategy, 'options.data_providers.db_fetch');
        },

        ...mapState(DataGatheringsStore, [
            'types',
            'academicPeriods',
        ]),
    },

    filters: {
        /**
         * @see toHumanSize
         * @returns {string}
         */
        toHumanSize: toHumanSize,
    }
}
